import { Base } from "./base";

export class WindTurbine extends Base {
    
    constructor(properties: Map<string, string | number>) {
        super(properties);
    }
}